import { MeasurementSystem } from '../../../components/unit-conversion/types';

export interface IUser {
  id: number;
  email: string;
  name: string;
  adminRole?: string;
  adminTeams?: number[]; // ids of teams the user is an admin of
  roles: string[];
  isActive: boolean;
  allowPasswordAuth?: boolean;
  isSSO?: boolean;
  isSuperAdmin: boolean;
  isOrgAdmin: boolean;
  hasAvatar?: boolean;
  thumbnailS3Path?: string;
  organizationId: number;
  numberOfProjects?: number;
  numberOfEditableProjects?: number;
  numberOfOwnedProjects?: number;
  numberOfTeams?: number;
  officeLocation?: string;
  professionalRole?: string;
  settings?: UserSettings;
}

export type UserSettings = {
  measurementSystemWeb?: MeasurementSystem;
  measurementSystemMobile?: MeasurementSystem;
};

export type UpdateUserAvatarFields = {
  id: number;
  image: string;
  organizationId: number;
};

export interface IUserState {
  user: IUser | null;
  userAvatarTimestamp: number;
  measurementSystem?: MeasurementSystem;
}

export const UserInitial: IUser = {
  id: 0,
  email: '',
  name: '',
  adminRole: '',
  roles: [],
  isActive: true,
  allowPasswordAuth: true,
  isSSO: false,
  isSuperAdmin: false,
  isOrgAdmin: false,
  organizationId: 0,
};
